import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import Image from '@/components/Image';
import { StrapiImage } from '@/types/common';
import css from './style.module.scss';
interface Props {
  image: StrapiImage;
}
const Slide: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    image
  } = t0;
  const t1 = image.alternativeText ?? "";
  let t2;
  if ($[0] !== image.height || $[1] !== image.url || $[2] !== image.width || $[3] !== t1) {
    t2 = <div className={css.slide}><Image width={image.width} height={image.height} src={image.url} preload={false} alt={t1} /></div>;
    $[0] = image.height;
    $[1] = image.url;
    $[2] = image.width;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default Slide;